import { Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import Icon from '~/components/Icon'
import { useState } from 'react'
import styled from 'styled-components'
import SharedTitle from '~/components/UI/SharedTitle'

const MyContainer = styled(Container)`
  table {
    background-color: rgba(235, 243, 255, 0.4);
    tr:nth-child(even) {
      td {
        text-align: center;
        background-color: #ebf3ff;
      }
    }
    td {
      width: 50%;
      padding: 10px;
      border: 1px solid rgba(235, 243, 255, 0.4);

      :nth-child(2) {
        background-color: #0084ff;
        color: #fff;
      }
    }

    select {
      border: 1px solid rgba(26, 26, 26, 0.1);
      padding: 0 5px;
    }
  }
`

const TableCompareMobile = () => {
  const [t] = useTranslation()
  const [loan, setLoan] = useState(true)
  const onChange = (evt: any) => {
    setLoan(evt.target.value === 'loan')
  }
  return (
    <MyContainer>
      <SharedTitle padding='45px 0' centered className='fz-34 title center'>
        {t`Bảng tính mô phỏng đầu tư`}
      </SharedTitle>
      <div style={{ border: '1px solid rgba(26, 26, 26, 0.1)', borderRadius: 8, overflow: 'hidden' }}>
        <table>
          <tbody>
            <tr>
              <td className='center'>
                <p className='fz-18 title'>{t`Truyền Thống`}</p>
                <select style={{ textAlignLast: 'center' }} onChange={onChange} value={loan ? 'loan' : 'no_loan'}>
                  <option value='no_loan'>
                    {t`Không vay`}
                  </option>
                  <option value='loan'>
                    {t`Có vay`}
                  </option>
                </select>
              </td>
              <td className='center fz-18 title'>
                <span style={{ marginRight: 10 }}>
                  {t`Infina`}
                </span>
                <Icon name='verified' />
              </td>
            </tr>
            <tr>
              <td colSpan={2}>{t`Vốn cần có`}</td>
            </tr>
            <tr>
              <td>
                {loan
                  ? t`450 triệu - 600 triệu`
                  : t`1.5 tỷ - 2 tỷ`
                }
              </td>
              <td>
                {t`20 triệu - 200 triệu`}
              </td>
            </tr>
            <tr>
              <td colSpan={2}>{t`Đóng theo tiến độ ( 5%/đợt )`}</td>
            </tr>
            <tr>
              <td>
                {loan
                  ? <>
                    {t`450 triệu - 600 triệu`}
                    <p style={{ fontWeight: 'normal', fontSize: 13 }}>
                      {t`(đóng đủ trong vòng 1 - 2 tháng)`}
                    </p>
                  </>
                  : t`Từ 75 triệu/đợt`
                }
              </td>
              <td>
                {t`Từ 10 triệu/đợt`}
              </td>
            </tr>
            <tr>

              <td colSpan={2}>{t`Gốc hàng tháng trả ngân hàng`}</td>
            </tr>
            <tr>
              <td>
                {loan
                  ? <>
                    {t`4,5 triệu - 6 triệu`}
                    <p style={{ fontWeight: 'normal', fontSize: 13 }}>
                      {t`(nếu CĐT không hỗ trợ)`}
                    </p>
                  </>
                  : t`0`
                }
              </td>
              <td>
                {t`0`}
              </td>
            </tr>
            <tr>
              <td colSpan={2}>{t`Lãi vay hàng tháng trả ngân hàng`}</td>
            </tr>
            <tr>
              <td>
                {loan
                  ? <>
                    {t`9 triệu - 12 triệu`}
                    <p style={{ fontWeight: 'normal', fontSize: 13 }}>
                      {t`(nếu CĐT không hỗ trợ)`}
                    </p>
                  </>
                  : t`0`
                }
              </td>
              <td>
                {t`0`}
              </td>
            </tr>
            <tr>
              <td colSpan={2}>{t`Tổng tiền hàng tháng phải trả ngân hàng`}</td>
            </tr>
            <tr>
              <td>
                {loan
                  ? <>
                    {t`13.5 triệu - 18 triệu`}
                    <p style={{ fontWeight: 'normal', fontSize: 13 }}>
                      {t`(nếu CĐT không hỗ trợ)`}
                    </p>
                  </>
                  : t`0`
                }
              </td>
              <td>
                {t`0`}
              </td>
            </tr>
            <tr>
              <td colSpan={2}>{t`Kênh giao dịch`}</td>
            </tr>
            <tr>
              <td>
                {t`Thị trường truyền thống`}
              </td>
              <td>
                {t`Thị trường truyền thống & Hệ sinh thái Infina`}
              </td>
            </tr>
            <tr>
              <td colSpan={2}>{t`Tính thanh khoản`}</td>
            </tr>
            <tr>
              <td>
                {t`Theo tình hình thị trường`}
              </td>
              <td>
                {t`Infina cam kết mua lại bất cứ lúc nào trong 2 năm đầu`}
              </td>
            </tr>
            <tr>
              <td colSpan={2}>{t`Lợi nhuận cam kết`}</td>
            </tr>
            <tr>
              <td>
                {t`Không ai cam kết, tuỳ vào thị trường`}
              </td>
              <td>
                {t`Có thể từ 6% đến 9% một năm`}
                <p style={{ fontWeight: 'normal', fontSize: 13 }}>
                  {t`(nhận thêm tiền lời khi bán ra)`}
                </p>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>{t`Tính an toàn của khoản đầu tư`}</td>
            </tr>
            <tr>
              <td>
                {t`Phụ thuộc hoàn toàn vào CĐT`}
              </td>
              <td>
                {t`Khoản đầu tư được bảo lãnh 100% bởi ngân hàng`}
              </td>
            </tr>
            <tr>
              <td colSpan={2}>{t`Thủ tục pháp lý`}</td>
            </tr>
            <tr>
              <td>
                {t`Tự tìm hiểu hoặc thông qua bên môi giới`}
              </td>
              <td>
                {t`Có Infina đồng hành cùng sự cố vấn pháp lý của công ty luật quốc tế`}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </MyContainer>
  )
}

export default TableCompareMobile
